module.exports = __webpack_public_path__ + "img/ccic-logo-white.e2a51301.svg";